import React from 'react';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import {
  CoreLink,
  Menu,
  Block,
  View,
} from '@uncinc/react-drupal-core';

import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import config from 'react-global-configuration';

import {
  BLOCK_CONTACT_BLOCK_ID,
  BLOCK_VISITING_ADDRESS_BLOCK_ID,
} from '../../../config/constants';

const VISITING_ADDRESS_INDEX_IDENTIFIER = 1;
const CONTACT_INDEX_IDENTIFIER = 2;

import './style.scss';

const MenuFooter = ({ id = 'footer' }) => {
  const { t } = useTranslation();
  const currentLanguage = useSelector((state) => state.getIn(['ui', 'language']));
  const API_URL = config.get('API_URL');

  return (
    <div className="FooterMenu">
      <Container>
        <Menu id={id}>
          {(items) => {
            return (
              <div className="row">
                <div className="col-12 col-lg-3">
                  <div className="FooterMenu__logo__wrapper">
                    <a aria-label={t('general.image_company')} href="/" className="FooterMenu__logo">
                      {/* logo is set as a background image in the stylesheet */}
                    </a>
                  </div>
                </div>

                {items.map((item, index) => {
                  const key = item.getIn(['link', 'meta_data', 'entity_id']);
                  const title = item.getIn(['link', 'title'], 'Untitled');
                  const titleUrl = item.getIn(['link', 'url']);
                  const url = `${API_URL}${titleUrl}`;

                  return (
                    <div
                      key={key}
                      className="FooterMenu__item col-12 col-md-4 col-lg-3"
                    >
                      {/* Render the Heading Title of the section */}
                      {titleUrl !== '' ? (
                        <CoreLink
                          className="FooterMenu__item__TitleLink"
                          to={url}
                        >
                          {title}
                        </CoreLink>
                      ) : (
                        <h2 className="asH4">
                          {title}
                        </h2>
                      )}

                      {/* Load in the Contact address block */}
                      {index === CONTACT_INDEX_IDENTIFIER && (
                        <Block currentLanguage={currentLanguage} id={BLOCK_CONTACT_BLOCK_ID} />
                      )}

                      {/* Load in the certifications */}
                      {index === CONTACT_INDEX_IDENTIFIER && (
                        <View
                          id="certfications"
                          display="block_1"
                        />
                      )}

                      {/* Render the menu items inside the section */}
                      {item.getIn(['subtree']).map((subItem, index) => {
                        const linkHref = subItem.getIn(['link', 'url']);
                        const linkTitle = subItem.getIn(['link', 'title'], '');
                        const url = `${API_URL}${linkHref}`;

                        return (
                          <div key={`footer-item-${index}`}>
                            <CoreLink
                              className="FooterMenu__item__link"
                              to={url}
                            >
                              {linkTitle}
                            </CoreLink>
                          </div>
                        );
                      })}

                      {/* Load in the Visiting address block */}
                      {index === VISITING_ADDRESS_INDEX_IDENTIFIER && (
                        <div className="FooterMenu__item__contact-block">
                          <h2 className="asH4">{t('general.visiting_address')}</h2>
                          <Block currentLanguage={currentLanguage} id={BLOCK_VISITING_ADDRESS_BLOCK_ID} />
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            );
          }}
        </Menu>
      </Container>
    </div>
  );
};

export default MenuFooter;
